module.exports = __webpack_public_path__ + "assets/img/Type E (64).f424885e.jpg";